import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, PlusCircle, PawPrint, MessageSquare, LogOut, Scissors } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

const links = [
  { to: "/client", end: true, icon: Home, label: "Home", tid: "cnav-home" },
  { to: "/client/book", icon: PlusCircle, label: "Book", tid: "cnav-book" },
  { to: "/client/pets", icon: PawPrint, label: "My pets", tid: "cnav-pets" },
  { to: "/client/messages", icon: MessageSquare, label: "Chat", tid: "cnav-messages" },
];

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#1F1A17]">
      <header className="border-b border-[#E5DCCE] bg-white">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[#C85A17] grid place-content-center text-white">
              <Scissors className="w-4 h-4"/>
            </div>
            <div>
              <div className="font-display font-bold leading-none">PawTrek</div>
              <div className="text-[10px] text-[#6B625B] uppercase tracking-wider mt-1">Hi, {user?.name?.split(" ")[0]}</div>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-1">
            {links.map(({ to, end, icon: Icon, label, tid }) => (
              <NavLink key={to} to={to} end={end} data-testid={tid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium transition-colors ${
                    isActive ? "bg-[#F5E6CF] text-[#A9480F]" : "text-[#6B625B] hover:bg-[#F3EDE4]"
                  }`
                }>
                <Icon className="w-4 h-4"/> {label}
              </NavLink>
            ))}
          </nav>
          <Button size="sm" variant="ghost" onClick={() => { logout(); nav("/"); }} data-testid="cbtn-logout">
            <LogOut className="w-4 h-4 mr-1"/> <span className="hidden md:inline">Sign out</span>
          </Button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto pb-24 md:pb-8"><Outlet/></main>

      <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-[#E5DCCE] grid grid-cols-4">
        {links.map(({ to, end, icon: Icon, label, tid }) => (
          <NavLink key={to} to={to} end={end} data-testid={`${tid}-mobile`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 py-2 text-[10px] font-semibold ${
                isActive ? "text-[#C85A17]" : "text-[#6B625B]"
              }`
            }>
            <Icon className="w-5 h-5"/> {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
